// extracted by mini-css-extract-plugin
export default {"learn_more":"LearnMore_learn_more__qdGeU","image":"LearnMore_image__XcSh0"};